import { useMetals, fmtMoney } from "../hooks/useMetals";
import { useLang } from "../i18n";
import Marquee from "./Marquee";

const ITEMS = [
  { symbol: "XAU", label: "AU 24K", purity: 0.999 },
  { symbol: "XAU", label: "AU 18K", purity: 0.75 },
  { symbol: "XAU", label: "AU 14K", purity: 0.585 },
  { symbol: "XAG", label: "AG 925", purity: 0.925 },
  { symbol: "XPT", label: "PT 950", purity: 0.95 },
  { symbol: "XPD", label: "PD 950", purity: 0.95 },
];

export default function Ticker() {
  const metals = useMetals();
  const { L } = useLang();

  return (
    <div data-testid="live-metal-price-ticker" className="bg-[#0E3B33] py-2.5">
      <Marquee duration={70}>
        {ITEMS.map((it, i) => {
          const spot = metals?.prices?.find((p) => p.symbol === it.symbol);
          const price = spot ? spot.eur_per_gram * it.purity : null;
          return (
            <span key={i} data-testid={`ticker-item-${it.label.replace(/\s/g, "-").toLowerCase()}`} className="mx-8 flex items-center gap-3 mono-tech">
              <span className="text-[#C9A84C]">{it.label}</span>
              <span className="text-[#F1ECDD] normal-case tracking-normal font-medium text-xs">
                {price ? `${fmtMoney(price)}/g` : "····/g"}
              </span>
              <span className="text-amber-600/50">◆</span>
            </span>
          );
        })}
        <span className="mx-8 flex items-center gap-2 mono-tech">
          <span className={`inline-block h-1.5 w-1.5 rounded-full ${metals ? (metals.stale ? "bg-amber-500" : "bg-emerald-400") : "bg-white/40"} animate-pulse`} />
          <span className="text-[#F1ECDD]/60">{metals ? (metals.stale ? L({ en: "Delayed spot", it: "Spot differito" }) : L({ en: "Live spot", it: "Spot live" })) : L({ en: "Connecting", it: "Connessione" })}</span>
          <span className="text-amber-600/50">◆</span>
        </span>
      </Marquee>
    </div>
  );
}
